import { DigitalTransformation } from './DigitalTransformation'
import { MicrosoftDynamics } from './MicrosoftDynamics'

export const Projects = {
  DigitalTransformation: DigitalTransformation,
  MicrosoftDynamics: MicrosoftDynamics
}
